// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3BOKB","title":"ClientInsurance_title__3QZ-h","itemText":"ClientInsurance_itemText__3JNfF"};